// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_-sx3C","swiper":"swiper_8-WwN"};